<template>
  <!-- Lead kartı drawer'ının (1002) ve modalların üstünde görünsün -->
  <div
    class="mx-auto top-20 right-0 left-0 w-full md:w-96 mt-4 fixed"
    style="z-index: 1020;"
  >
    <transition-group name="slide-down">
      <div
        style="z-index: 60; position: relative;"
        :key="message.uid"
        v-for="(message, index) in messages"
      >
        <div>
          <div class="bg-white p-2 shadow border mb-2 mx-2 rounded-lg">
            <div class="flex w-full justify-between items-start space-x-2">
              <div class="flex w-full justify-start items-center space-x-2">
                <div
                  v-if="message.type == 'success'"
                  class="bg-jgreen-50 bg-opacity-40 p-2 flex items-center justify-center text-white rounded-lg"
                >
                  <div
                    class="bg-jgreen rounded-full px-1 h-6 w-6 items-center justify-center flex"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="m10 16.4l-4-4L7.4 11l2.6 2.6L16.6 7L18 8.4z"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  v-if="message.type == 'error'"
                  class="bg-tile-50 bg-opacity-40 p-2 flex items-center justify-center text-white rounded-lg"
                >
                  <div
                    class="bg-tile-500 rounded-full px-1 h-6 w-6 items-center justify-center flex"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M12 17q.425 0 .713-.288Q13 16.425 13 16t-.287-.713Q12.425 15 12 15t-.712.287Q11 15.575 11 16t.288.712Q11.575 17 12 17Zm0 5q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-9q.425 0 .713-.288Q13 12.425 13 12V8q0-.425-.287-.713Q12.425 7 12 7t-.712.287Q11 7.575 11 8v4q0 .425.288.712q.287.288.712.288Z"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  v-if="message.type == 'info'"
                  class="bg-blue-50 bg-opacity-40 p-2 flex items-center justify-center text-white rounded-lg"
                >
                  <div
                    class="bg-blue-500 rounded-full px-1 h-6 w-6 items-center justify-center flex"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-6 h-6"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M12 22q-.825 0-1.412-.587T10 20h4q0 .825-.587 1.413T12 22m-7-3q-.425 0-.712-.288T4 18q0-.425.288-.712T5 17h1v-7q0-2.075 1.25-3.687T10.5 4.2v-.7q0-.625.438-1.062T12 2q.625 0 1.063.438T13.5 3.5v.325q-.275.55-.4 1.125T13 6.125q-.25-.05-.488-.088T12 6q-1.65 0-2.825 1.175T8 10v7h8v-6.425q.45.2.963.313T18 11v6h1q.425 0 .713.288T20 18q0 .425-.288.713T19 19zM18 9q-1.25 0-2.125-.875T15 6q0-1.25.875-2.125T18 3q1.25 0 2.125.875T21 6q0 1.25-.875 2.125T18 9"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  v-if="message.type == 'upload'"
                  class="flex-1 flex space-x-2 w-full"
                >
                  <div
                    class="bg-jgreen-50 bg-opacity-40 p-2 flex items-center justify-center text-white rounded-lg"
                  >
                    <div
                      class="bg-jgreen-500 rounded-full px-1 h-6 w-6 items-center justify-center flex"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-6 h-6"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="m2.859 2.877l12.57-1.795a.5.5 0 0 1 .571.494v20.848a.5.5 0 0 1-.57.494L2.858 21.123a1 1 0 0 1-.859-.99V3.867a1 1 0 0 1 .859-.99M4 4.735v14.53l10 1.429V3.306zM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4zm-6.8-7l2.8 4h-2.4L9 13.714L7.4 16H5l2.8-4L5 8h2.4L9 10.286L10.6 8H13z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div
                      class="mb-2 flex-1 w-full justify-between items-center"
                    >
                      <h3
                        class="font-medium m-0 mb-1 p-0 text-xs"
                        v-if="message.percentage < 99"
                      >
                        Veriler yükleniyor
                      </h3>
                      <h3 class="font-medium m-0 mb-1 p-0 text-xs" v-else>
                        Veriler yüklendi
                      </h3>
                    </div>
                    <div
                      class="flex w-full h-2 bg-gray-200 rounded-full overflow-hidden dark:bg-gray-700"
                      role="progressbar"
                      :aria-valuenow="message.percentage"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      <div
                        class="flex flex-col justify-center rounded-full overflow-hidden bg-jgreen-400 text-xs text-white text-center whitespace-nowrap transition duration-500 dark:bg-blue-500"
                        :style="'width:' + message.percentage + '%'"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <h3
                    v-if="message.title"
                    class="font-medium m-0 mb-1 p-0 text-xs"
                  >
                    {{ message.title }}
                  </h3>
                  <div class="text-xs">
                    {{ message.body }}
                    <a
                      :href="message.url.url"
                      v-if="message.url"
                      class="global-button-xs text-black"
                      >{{ message.url.label }}</a
                    >
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 cursor-pointer w-4"
                @click="close(index)"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
    <div
      v-if="messages.length > 0 && blocked"
      class="fixed inset-0 bg-gray-800 bg-opacity-75 z-40"
    ></div>
  </div>
</template>

<script>
import EventBus from "./Ui/EventBus";
import debug from "../services/notificationDebug";

export default {
  data() {
    return {
      messages: [],
      blocked: false,
      nextUid: 0,
    };
  },
  methods: {
    close(index) {
      // indexOf -1 dönerse splice(-1, 1) son toast'ı (çoğu zaman yeni gelen
      // bildirimi) siliyordu.
      if (index < 0 || index >= this.messages.length) return;
      debug("toast: kapatıldı", {
        uid: this.messages[index].uid,
        key: this.messages[index].key,
        remaining: this.messages.length - 1,
      });
      this.messages.splice(index, 1);
    },
    closeMessage(message) {
      this.close(this.messages.indexOf(message));
    },
  },
  mounted() {
    EventBus.$on("bottomMessage", (data) => {
      if (data.type != "upload") {
        // Aynı bildirim (aynı key) zaten açıksa üstüne yaz, ikinci toast açma.
        if (data.key) {
          const existing = this.messages.find((m) => m.key === data.key);
          if (existing) {
            existing.body = data.body;
            existing.title = data.title;
            existing.url = data.url;
            debug("toast: açık olan güncellendi", data.key);
            return;
          }
        }

        const newMessage = {
          uid: ++this.nextUid,
          key: data.key,
          isOpen: true,
          body: data.body,
          url: data.url,
          title: data.title,
          type: data.type,
          duration: data.duration,
        };
        this.blocked = true;

        if (data.duration) {
          this.blocked = false;

          setTimeout(() => {
            newMessage.isOpen = false;
            this.closeMessage(newMessage);
          }, data.duration);
        }

        this.messages.push(newMessage);
        debug("toast: açıldı", {
          uid: newMessage.uid,
          key: newMessage.key,
          type: newMessage.type,
          duration: newMessage.duration,
          open: this.messages.length,
        });
      } else {
        // Eski davranış korunur: ilk olay toast'ı açar, sonraki olaylar aynı
        // toast'ı ilerleme çubuğuna çevirir, %99'da kapanır. Fark: artık
        // messages[0] ne olursa olsun (ör. açık bir bildirim) üstüne
        // yazılmaz, sadece yükleme toast'ı güncellenir.
        let upload = this.messages.find((m) => m.type == "upload");
        const created = !upload;
        if (created) {
          upload = {
            uid: ++this.nextUid,
            isOpen: true,
            type: "upload",
            percentage: 0,
          };
          this.messages.push(upload);
        }
        upload.body = data.body;
        upload.url = data.url;
        upload.title = data.title;
        upload.duration = data.duration;
        upload.percentage = (data.count[0] / data.count[1]) * 100;

        if (upload.percentage >= 99) {
          if (created) {
            // Tek parçada biten yükleme: eskiden olduğu gibi sonuç mesajı
            // kalıcı bir "success" toast'ı olarak kalır.
            upload.type = "success";
          } else {
            this.closeMessage(upload);
          }
        }

        this.$forceUpdate();

        if (data.duration) {
          this.blocked = false;

          setTimeout(() => {
            this.closeMessage(upload);
          }, data.duration);
        }
      }
    });
  },
};
</script>
<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.2s ease-in-out;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateX(100%);
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 40;
}
</style>
